import { InfoOutlineIcon } from '@chakra-ui/icons';
import { Fade, Flex, Text } from '@chakra-ui/react';

const FieldError = ({ message, fontSize = '12px', color = 'danger.500', mt = '0' }) => {
    if (!message) return null;
    return (
        <Fade in={message}>
            <Flex alignItems={'center'} gap={'8px'} mt={mt}>
                <InfoOutlineIcon color={color} fontSize={fontSize} />
                <Text fontSize={fontSize} color={color}>
                    {message}
                </Text>
            </Flex>
        </Fade>
    );
};

export default FieldError;
